import Vue from 'vue';
import Vuex from 'vuex';
import office from './office';
import menu from './menu';
import bookmark from './bookmark';
import group from './group';
import notification from './notification';
import cache from './cache';
import plusapp from './plusapp';
import multiOffice from './multiOffice';
import banner from './banner';

Vue.use(Vuex);

const initialState = () => {};

const getters = {};

const mutations = {};

const actions = {};

export default new Vuex.Store({
  state: initialState,
  modules: {
    office: office,
    menu: menu,
    bookmark: bookmark,
    group: group,
    notification: notification,
    cache: cache,
    plusapp: plusapp,
    multiOffice: multiOffice,
    banner: banner,
  },
  mutations,
  actions,
  getters,
  strict: process.env.NODE_ENV !== 'production',
});
